import {
    CHARGEBACK_STATUS_ENUM,
    DEFAULT_CURRENCY,
} from '../../../utils/constants/commonValues';
import { isPresentOrDefault } from '../../../utils/helperMethods';
import moment from 'moment';

function ChargeBackList(data) {
    this.tableData = this.createTableData(data);
    this.pagination = this.createPaginationData(data.paginationDetails);
}

ChargeBackList.prototype = Object.assign(ChargeBackList.prototype, {
    createTableData(tableData) {
        return (
            (tableData &&
                tableData.chargebackListDataList &&
                tableData.chargebackListDataList.map(row =>
                    this.createRow(row))) ||
            []
        );
    },
    createPaginationData(data) {
        if (data) {
            const { pageNo, pageSize, totalElements } = data;

            return {
                pageSize,
                pageNumber: pageNo,
                pageCount: Math.ceil(totalElements / pageSize),
            };
        }
        return {
            pageNo: 1,
            pageSize: 10,
            totalElements: 0,
        };
    },
    createRow(row) {
        const {
            merchantName,
            chargebackDate,
            chargebackId,
            orderId,
            paymentType,
            cbStatus,
            priority,
            chargebackAmount,
            type
        } = row;
       //console.log(type,cbStatus,".....");
        return {
            priority: isPresentOrDefault(priority, '-'),
            merchantName: merchantName || '-',
            createdDate: chargebackDate
                ? moment(chargebackDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
                : '-',
            chargebackId: chargebackId || '-',
            orderId: orderId || '-',
            paymentType: paymentType ? paymentType : '-',
            chargebackStatus: isPresentOrDefault(
                CHARGEBACK_STATUS_ENUM[cbStatus].label,
                '-'
            ),
            amount: chargebackAmount
                ? `${DEFAULT_CURRENCY} ${chargebackAmount}`
                : '-',
            type: type? type : "CHARGEBACK"
            // ? type : "CHARGEBACK"

        };
    },
});

export default ChargeBackList;
